module.exports = __webpack_public_path__ + "static/img/site-6.8146634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/site-6.png
// module id = ZgeB
// module chunks = 0